import { FeedbackBody } from "@/src-refactor/modules/store/qrtk/services/realestate/values/feedback-realestate.value";
import { IAssessmentForm } from "./form.util";
import { O_RATING_FEEDBACK } from "@/src-refactor/modules/shared/model/const/realestate/rating-feedback.const";
import { SUBJECTS_FEEDBACK } from "@/src-refactor/modules/shared/model/const/realestate/subjec-feedback.const";

export const assessmentAdapter = (values: IAssessmentForm): FeedbackBody => {
  const serverProperties: FeedbackBody = {};
  if (values.comment) {
    serverProperties.comment = values.comment;
  }

  if (values.rating) {
    serverProperties.rating = O_RATING_FEEDBACK[values.rating].value;
  }

  if (values.isProject) {
    serverProperties.subject_id = SUBJECTS_FEEDBACK.PROJECT_CREATE.id;
  } else {
    serverProperties.subject_id = SUBJECTS_FEEDBACK.CREATE.id;
  }

  return serverProperties;
};
